<template>
  <div class="swiper_wrap">
    <div class="gallerytop">
      <v-product-tag
        v-if="is_product && $store.state.product_tag_list[product_res.ID]"
        :productTag="$store.state.product_tag_list[product_res.ID]"
        :productInfo="productInfo"
      ></v-product-tag>
      <swiper
        :class="{ 'swiper-no-swiping': gallery.length <= 1 }"
        ref="gallerytop"
        class="swiper"
        :options="galleryTop"
        @slideChange="slideChange"
      >
        <swiper-slide class="product-swiper__slide" v-for="item in gallery" :key="item.ID" style="text-align: center">
          <v-picZoom
            class="product-swiper__piczoom"
            v-if="pic_zoom && (item.media_content_type == 'image' || item.media_content_type == 'external_image')"
            :thumbnail="item.thumbnail"
            :url="item.url"
            :bigUrl="item.url"
            :appendToBody="true"
          >
          </v-picZoom>
          <v-media-card
            v-else
            :type="item.media_content_type"
            :src="item.url"
            :url="item.url"
            :thumbnail="item.thumbnail"
            :autoplay="false"
            :show-play-button="false"
            :muted="true"
            :height-scale="100"
          />
        </swiper-slide>
      </swiper>
    </div>
    <div class="thumbs d-md-block d-none">
      <swiper ref="gallerythumbs" class="swiper gallerythumbs" :options="galleryThumbs">
        <swiper-slide class="thumbs__slide" v-for="item in gallery" :key="item.ID" style="text-align: center">
          <span @click="tonews(item.ID)">
            <i
              v-if="item.media_content_type === 'video' || item.media_content_type === 'external_video'"
              class="thumbs__video-icon"
              :class="{
                'el-icon-video-play': item.media_content_type === 'video',
                'iconfont icon-cm-youtube': item.media_content_type === 'external_video',
              }"
            ></i>
            <img
              data-sizes="auto"
              :src="item.thumbnail || defaultImage"
              class="lazyload"
              @load="gallerythumbs.update()"
              @error.once="imageFailure($event, defaultImage)"
              @mousemove.prevent
              width="100%"
            />
          </span>
        </swiper-slide>
      </swiper>

      <div v-if="gallery.length > 5" class="button-prev">
        <i class="iconfont icon-a-ziyuan10"></i>
      </div>
      <div v-if="gallery.length > 5" class="button-next">
        <i class="iconfont icon-a-ziyuan9"></i>
      </div>
    </div>
  </div>
</template>

<script>
import { playVideo } from '@/js/lib/util'
import mediaCard from '@/js/components/MediaCard.vue'
import vProductTag from '@/js/components/view/productTag/productTag.vue'
import vPicZoom from '@/js/components/common/picZoom.vue'

export default {
  components: {
    [mediaCard.name]: mediaCard,
    vProductTag,
    vPicZoom
  },
  props: [
    'gallery',
    'pic_zoom',
    'pagination_style',
    'theme',
    'option',
    'swiper_index',
    'hiddenbtn',
    'is_product',
    'product_res',
    'productInfo',
  ],
  data() {
    return {
      galleryTop: {
        autoHeight: true,
        loop: true,
        thumbs: {
          swiper: this.gallerythumbs,
        },
        //Swiper4.x版本为小于
        breakpoints: {
          768: {
            spaceBetween: 15,
          },
        },
        noSwiping: true,
        noSwipingClass: 'swiper-no-swiping',
        pagination: {
          el: '.swiper-pagination',
          bulletClass: 'my-bullet', //需设置.my-bullet样式
          bulletActiveClass: 'my-bullet-active',
          // clickable: true,
          // renderBullet: (index, className) => {
          //   return `<span class=" ${className} "> <img src="${this.gallery[index].thumbnail}" ></span>`;
          // },
        },
        on: {
          slideChangeTransitionEnd: this.handChangeEnd,
        },
      },
      galleryThumbs: {
        spaceBetween: 10,
        slidesPerView: 5,
        navigation: {
          nextEl: '.button-next',
          prevEl: '.button-prev',
        },
        on: {
          // slideChangeTransitionStart: this.onTransitionStart,
        },
      },
      el: null,
    }
  },
  mounted() {
    const dom = this.$refs.gallerytop?.swiper?.el
    this.el = dom

    const thisVideoDom = dom && Jq(dom)?.find('.swiper-slide-active [video-src]')?.[0]

    if (thisVideoDom) playVideo(thisVideoDom, 1)
  },
  methods: {
    // onTransitionStart() {
    //   console.log(this.gallerythumbs.activeIndex);
    //   this.gallery.forEach((item, index) => {
    //     if (this.gallerythumbs.activeIndex == index) {
    //       this.gallerytop.slideTo(index);
    //     }
    //   });
    // },
    tonews(id) {
      this.gallery.forEach((element, index) => {
        if (element.ID == id) {
          this.gallerytop.slideTo(index + 1)
        }
      })
    },
    slideChange() {
      const videoDom = this.el && Jq(this.el)?.find('.swiper-slide-active [video-src]')?.[0]
      if (!videoDom) return

      playVideo(videoDom, 0)
    },
    // 结束切换
    handChangeEnd(a) {
      const videoDom = this.el && Jq(this.el)?.find('.swiper-slide-active [video-src]')?.[0]
      if (!videoDom) return
      playVideo(videoDom, 1)
    },
  },
  computed: {
    gallerytop() {
      return this.$refs.gallerytop.swiper
    },
    gallerythumbs() {
      return this.$refs.gallerythumbs.swiper
    },
  },
  watch: {
    '$store.state.feature_image_id'() {
      this.gallery.some((item, index) => {
        if (item.ID == this.$store.state.feature_image_id) {
          this.gallerytop.slideTo(index + 1)
        }
      })
    },
  },
}
</script>

<style lang='scss' scoped>
.product-swiper {
  &__slide {
    background-color: #f5f5f7;
  }
  // 放大镜 的样式
  &__piczoom {
    &::v-deep {
      &.mirror {
        position: relative;
        padding-bottom: 100%;
        height: 0;
        width: 100%;
        display: block;
        .wrap {
          position: absolute;
          width: 100% !important;
          height: 100% !important;
          top: 0;
          left: 0;
          & > div {
            width: 100% !important;
            height: 100% !important;
            background-color: #f5f5f7;
            img {
              object-fit: contain;
            }
          }
        }
      }
    }
  }
}
.swiper_wrap {
  // margin-right: 5%;
  .gallerytop {
    margin-bottom: 20px;
    position: relative;
  }
  .thumbs {
    position: relative;
    width: calc(100% - 100px);
    margin: 0 auto;
    margin-bottom: 30px;
    &__slide {
      position: relative;
    }
    &__video-icon {
      position: absolute;
      z-index: 2;
      font-size: 30px;
      color: #fff;
      height: 100%;
      width: 100%;
      background: #00000035;
      top: 0;
      left: 0;
      &::before {
        position: absolute;
        bottom: 10px;
        right: 10px;
      }
    }
    .swiper-slide,
    .swiper-slide img {
      width: 94px !important;
      height: 94px !important;
    }
    .button-next,
    .button-prev {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      i {
        font-size: 32px;
        color: #858585;
      }
    }
    .button-prev {
      left: -50px;
    }
    .button-next {
      right: -50px;
    }
  }
}
@media screen and (max-width: 768px) {
  .swiper_wrap {
    &::v-deep {
      .tag {
        width: calc(100% - 60px);
        left: 30px;
      }
    }
    .gallerytop {
      margin-bottom: 0;
      position: relative;
      .swiper {
        overflow: inherit;
        width: calc(100% - 60px);
        // &::v-deep .swiper-wrapper {
        //   margin-left: -15px !important;
        // }
      }
      .swiper-pagination {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        bottom: 15px;
        display: flex;
        align-items: center;
        &::v-deep {
          .my-bullet {
            display: inline-block;
            width: 5px;
            height: 5px;
            background: #222a40;
            border-radius: 50%;
            margin: 0 5px;
          }
          .my-bullet-active {
            width: 10px;
            height: 10px;
            background: #222a40;
            border-radius: 50%;
          }
        }
      }
    }
  }
}
</style>
